import React, { useCallback } from "react";
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext.js';
import FormRenderer from '../Component/Forms/FormRenderer.js';
import ThemeControls from "../Component/AllThemesControl.js";
import { MasterContext } from '../services/MasterContext.js';
import { APIPOST, APIPATCH, APIGET, APIUPLOAD } from '../services/APIServices.js';
import { BiSolidPlusCircle, BiSolidMinusCircle } from "react-icons/bi";
import Dialog from '@mui/material/Dialog';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useParams } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function TabPanels(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [openTab, setOpenTab] = React.useState(0);
  const { contextJson, contextObjective, apiContextObj, setEditData } = React.useContext(FormJSONCreateContext);
  const [masterJson, setMasterJson] = React.useState(contextJson);
  // const [btnName, setBtnName] = React.useState(false);
  let navigate = useNavigate()
  const { id } = useParams();
  function handelnavigate(event, link) {
    event.preventDefault();
    navigate(link)
  }

  function cardOpen(index) {
    setOpenTab(prevTab => (prevTab === index ? -1 : index));
  }

  const objData = Object.keys(contextJson).map((key, index) => {
    const valiBtn = contextJson[key] && contextJson[key].fields && contextJson[key].fields.some(item => item.field_id === 'status' && item.field_value === 2);

    if (key !== "xioFEConfig" && contextJson[key].display_on_create !== "hide" && contextObjective === 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
            {contextJson[key].btn_name && (
              <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson[key].btn_link)}>
                {contextJson[key].btn_name}
              </button>
            )}
          </div>
          <FormRenderer formJSON={contextJson[key]} />
        </div>
      );
    } else if (key !== "xioFEConfig" && contextObjective !== 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
            <div className={classes.btnsfrm}>
              {contextJson[key].btn_name && (
                <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson[key].btn_link)}>
                  {contextJson[key].btn_name}
                </button>
              )}
            </div>
          </div>
          <FormRenderer formJSON={contextJson[key]} />
        </div>
      );
    }
    return null;
  });

  return objData;
}


function TabFormPart(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [openAlert, setOpenAlert] = React.useState(false);
  const { contextJson, renderSuccessPage } = React.useContext(FormJSONCreateContext);
  const { apiContextObj} = React.useContext(FormJSONCreateContext);
  let { contextObjective } = React.useContext(FormJSONCreateContext);
  const { masterData } = React.useContext(MasterContext);
  const [open, setOpen] = React.useState(false);
  const [previewData, setPreviewData] = React.useState();
  const [errorMsg, setErrorMsg] = React.useState('');
  const [msgtype, setMsgType] = React.useState('error');
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [payloadData, setPayloadData] = React.useState();
  // let navigate = useNavigate()

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setBtnLoading(false);
  };

  const hendleErrorMsg = useCallback((msg, type) => {
    if (msg) {
      setOpen(true);
      setErrorMsg(msg);
      setMsgType(type)
      setBtnLoading(false)
    }
  }, [setOpen, setErrorMsg]);

  function validateThisForm(jsonContext) {
    let return_error = true;
    jsonContext.fields.forEach(field => {
      if (!elementValidation(field)) {
        return_error = false;

        return false;
      }
    });
    return return_error;
  }

  function validateFullForm(contextJson) {
    let return_error = true;
    Object.keys(contextJson).forEach((key) => {
      if (key !== "xioFEConfig") {
        contextJson[key].fields.forEach(field => {
          if (!elementValidation(field)) {
            return_error = false;

            return false;
          }
        });
      }
    })
    return return_error;
  }


  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  async function postingData(apiSign,data) {
    console.log(data)
    masterData[`${apiContextObj.apiContextSave}`] = {}
    try {
      const response = await APIPOST(apiContextObj.apiContextSave + apiSign, data, contextJson, renderSuccessPage, hendleErrorMsg);
      // setPostResponse(response.data);
      if (response) {
        // setPostResponse(response.data);
        return response.data
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  function setpreviewData (data){
    setBtnLoading(false)
    setPreviewData(data.dataRecevied.data)
    setOpenAlert(true);
  }

  async function handleSave(event) {
    let apiSign = '/saveAll'
    postingData(apiSign ,payloadData)
    setBtnLoading(true)
  }

  async function handleSubmit(event) {
    setBtnLoading(true)
    event.preventDefault();
    window.scrollTo(0, 0);
    let isFormValid = true;
    const fdata = {};
    let Arry = [];
    const objData = {};
    let data;

    Object.keys(contextJson).forEach((key, _i) => {
      if (key !== "xioFEConfig") {
        const form = contextJson[key];
        isFormValid = validateFullForm(contextJson)
        if (isFormValid && validateFullForm(contextJson)) {
          form.fields.forEach((thisField) => {
            const { field_type, field_id, field_value, field_keyValue, url, field_data_type } = thisField;

          if (field_type === "dragDropSelect") {
              objData['id'] = field_id
              objData['value'] = field_value ? field_value : [];
            } else if (field_type !== "" && field_type !== "undefined") {
              fdata[field_id] = field_value;
            }
          });
        } else {
          setBtnLoading(false)
          console.log('form error')
        }
      }
    });


    async function previewData() {
      try {
        const response = await APIPOST(apiContextObj.apiContextSave +'/checkAll', data, contextJson, setpreviewData, hendleErrorMsg);
        // setPostResponse(response.data);
        if (response) {
          // setPostResponse(response.data);
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    if (isFormValid) {
      if (apiContextObj?.apiContextSave === "gtsAminformation") {
        const dataArray = objData?.value?.filter(item => !item.disabled)?.map(item => item.value);
        console.log(fdata)
        const result = dataArray.map((carrierId) => ({ ...fdata, [objData.id]: carrierId }));
  
        data = [...result];
        setPayloadData(data)
      } else {
        data = { ...fdata };
        setPayloadData(data)
      }
        if (contextObjective === "create") {
          previewData(data);
        }
    } else {
      const msg = 'Please Check Form for errors!';
      hendleErrorMsg(msg, 'error');
    }

    return false;
  }

  const fields = [
    { key: '1', title: 'Carrier Name', dataIndex: 'carrieridLabel' },
    { key: '2', title: 'AM Name', dataIndex: 'accountmidLabel' },
    { key: '3', title: 'Start Date', dataIndex: 'startdate' },
    { key: '4', title: 'End Date', dataIndex: 'enddate' },
  ];

  return (
    <>
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={msgtype} sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog
        // open='true'
        open={openAlert}
        maxWidth='lg'
        onClose={handleCloseAlert}
      >
      <DataTable data={previewData} fields={fields} close={handleCloseAlert} onSubmit={handleSave} heading={apiContextObj.contextHeading} btnLoading={btnLoading}/>
      </Dialog>
     
      <TabPanels hendleErrorMsg={hendleErrorMsg} />
      <div className={classes.fromBtn}>
          <button className="smtbtn" type="submit" onClick={handleSubmit} disabled={btnLoading}>
            {btnLoading ?
              <div class={classes.loading08}>
                <span data-text="L">L</span>
                <span data-text="O">O</span>
                <span data-text="A">A</span>
                <span data-text="D">D</span>
                <span data-text="I">I</span>
                <span data-text="N">N</span>
                <span data-text="G">G</span>
              </div> : "Submit"}
          </button>
      </div>
    </>
  );
}

export default TabFormPart;


const DataTable = ({ data, fields, close, onSubmit, heading, btnLoading }) => {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  return (
    <div className={classes.prevw}>
       <div className="heading">
          <h4>{heading}</h4>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>
      <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {fields.map((field) => (
              <TableCell key={field.key}sx={{ padding: '10px', fontWeight:600 }}>{field.title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              {fields.map((field) => (
                <TableCell key={field.key} sx={{ padding: '8px' }}>{row[field.dataIndex]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <div className='fromBtn'>
          <button className="smtbtn" type="submit" onClick={onSubmit} disabled={btnLoading}>
            {btnLoading ?
              <div class={classes.loading08}>
                <span data-text="L">L</span>
                <span data-text="O">O</span>
                <span data-text="A">A</span>
                <span data-text="D">D</span>
                <span data-text="I">I</span>
                <span data-text="N">N</span>
                <span data-text="G">G</span>
              </div> : "Save"}
          </button>
          <button className="cnlbtn" onClick={close} disabled={btnLoading}>Cancel</button>
      </div>
    </div>
  );
};

